import { IntlShape } from "react-intl";

const dateWeekdayDayMonthOptions: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
  weekday: "short",
};

export const formatDeliveryDates = (dates: string[], intl: IntlShape): string => {
  if (!dates[0]) {
    return `${intl.formatMessage({
      id: "cheerz_before",
    })} ${intl.formatDate(dates[1], dateWeekdayDayMonthOptions)}`;
  } else if (!dates[1]) {
    return `${intl.formatMessage({
      id: "cheerz_after",
    })} ${intl.formatDate(dates[0], dateWeekdayDayMonthOptions)}`;
  } else if (dates[0] === dates[1]) {
    return intl.formatDate(dates[0], dateWeekdayDayMonthOptions);
  } else {
    return `${intl.formatDate(dates[0], dateWeekdayDayMonthOptions)} - ${intl.formatDate(
      dates[1],
      dateWeekdayDayMonthOptions
    )}`;
  }
};
